export default __webpack_public_path__ + "static/media/blackringcitadelwing1.f0c37190.jpg";